import api from './axiosConfig';

const miObraService = {
  obtener: async () => {
    const { data } = await api.get('/mi-obra');
    return data;
  },
  registrarHito: async (clave) => {
    const { data } = await api.post('/mi-obra/hitos', { clave });
    return data;
  },
  registrarOferta: async (modulo, resultado) => {
    const { data } = await api.post('/mi-obra/ofertas', { modulo, resultado });
    return data;
  },
};

export default miObraService;
